import {type IdName} from 'client';

export const idNamesToIds = (IdNames: IdName[]) => {
  return IdNames.map(({id}) => id);
};
